<!-- FOR DEMO ONLY -- REMOVE ME -->
<div class="demo__switcher">
  <div class="flexie-auto-grid">
    <div>
      <small class="d-b">Product:</small>
      <nz-select nzShowSearch  [(ngModel)]="productType" style="width: 100%" (ngModelChange)="switchProduct(productType)" nzSize="small">
        <nz-option [nzLabel]="'Life Claim'" [nzValue]="'claims-life'"></nz-option>
        <nz-option [nzLabel]="'Health Claim'" [nzValue]="'claims-health'"></nz-option>
        <nz-option [nzLabel]="'Health Proposal'" [nzValue]="'underwriting-health'"></nz-option>
      </nz-select>
    </div>
    <div>
      <small class="d-b">Stage:</small>
      <nz-select nzShowSearch  [(ngModel)]="tempState" style="width: 100%" (ngModelChange)="handleStateChange(tempState)" nzSize="small" [nzDisabled]="productTypeConfig.productType!=='claims'">
        <nz-option [nzLabel]="'Intimation'" [nzValue]="'intimation'"></nz-option>
        <nz-option [nzLabel]="'Registration'" [nzValue]="'registration'"></nz-option>
        <nz-option [nzLabel]="'Adjudication'" [nzValue]="'adjudication'"></nz-option>
        <nz-option [nzLabel]="'Investigation'" [nzValue]="'investigation'"></nz-option>
        <nz-option [nzLabel]="'Payout'" [nzValue]="'payout'"></nz-option>
      </nz-select>
    </div>
    <div>
      <small class="d-b">Tabs:</small>
      <nz-select nzShowSearch  [(ngModel)]="nzTabPosition" style="width: 100%" nzSize="small">
        <nz-option [nzLabel]="'Horizontal'" [nzValue]="'top'"></nz-option>
        <nz-option [nzLabel]="'Vertical'" [nzValue]="'left'"></nz-option>
      </nz-select>
    </div>
  </div>
</div>
<!-- / FOR DEMO ONLY -- REMOVE ME -->

<div id="ribbon">
<div class="card-container" *ngIf="productTypeConfig.productType=='underwriting'">
  <div class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>#PP00900/920/HL172</span>&nbsp;
          <nz-tag [nzColor]="productTypeConfig.prodTagColor"><i nz-icon [nzType]="productTypeConfig.prodTagIcon"></i> {{productTypeConfig.prodSubType}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">Data Entry Complete</nz-tag>
        </div>
        <div>
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <!-- Mark as favourite -->
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">
      <div>
        <div class="grid grid-3x grid-gap-10 p-b-10">
          <div><strong class="c-s-heading">Proposal Number</strong> PP00900/920/HL172</div>
          <div><strong class="c-s-heading">Stage</strong> Pending Manual Underwriting</div>
          <div><strong class="c-s-heading">Submission Date</strong> 12 Nov 2018, 10:15 AM</div>
          <div><strong class="c-s-heading">Status</strong>  Data entry complete</div>
          <div><strong class="c-s-heading">Premium </strong> Rs. 50,000</div>
          <div><strong class="c-s-heading">Premium Status </strong> <nz-tag [nzColor]="'#d1861b'">Outstanding</nz-tag></div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="percentCompleted" [nzSuccessPercent]="percentCompleted-20"
                         nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>

      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="workflowPanel(1,1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> <span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i> Analytics</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>
</div>
<div class="card-container" *ngIf="productTypeConfig.productType=='claims'">
  <!-- Multiple *ngIf s used -- MAKE SAME COMPONENT IN PRODUCTION CODE. DO NOT COPY THIS METHOD -->
  <div *ngIf="state=='adjudication' || state=='investigation' || state=='payout'" class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>#CLM0000107</span>&nbsp;
          <nz-tag [nzColor]="productTypeConfig.prodTagColor"><i nz-icon [nzType]="productTypeConfig.prodTagIcon"></i> {{productTypeConfig.prodSubType}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">Pending Investigation</nz-tag>
        </div>
        <div>
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <!-- Mark as favourite -->
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">
      <div>
        <div class="grid grid-3x grid-gap-10 p-b-10">
          <div><strong class="c-s-heading">Policy Number</strong> <a (click)="policyPanel(1)">P0030547</a></div>
          <div><strong class="c-s-heading">Intimation Date</strong>2 April 2019, 3:30 PM</div>
          <div><strong class="c-s-heading">Claim Number</strong> CLM0000107</div>
          <div><strong class="c-s-heading">Policy Commencement</strong> 12 Nov 2018, 10:15 AM</div>
          <div><strong class="c-s-heading">Insured Name</strong> Chris Hemsworth</div>
          <div><strong class="c-s-heading">Claimed Amount </strong> Rs. 1.20 Cr</div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="percentCompleted" [nzSuccessPercent]="percentCompleted-20"
                         nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>

      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="workflowPanel(1,1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)"><i class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
        <!--<button nz-button [nzSize]="'small'" nzType="primary" nzGhost nz-popover nzTitle="Tasks Timeline" [nzContent]="tasksTimelineTemplate" nzTooltipPlacement="bottomRight">Track Tasks</button>-->
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> <span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i> Analytics</a>
      </div>
      <!--<div class="flex flex-both-center">
        <a href="javascript:void(0);" (click)="notesPanel(1)">
          <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon d-b"
             nz-tooltip nzTooltipTitle="My Notes" nzTooltipPlacement="center">
          </i>
          <nz-badge nzStatus="error">
          <small class="f-s-09r">Notes </small>
          </nz-badge>
        </a>
        <a href="javascript:void(0);" (click)="notesPanel(1)">
          <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon d-b"
             nz-tooltip nzTooltipTitle="My Notes" nzTooltipPlacement="center">
          </i>
          <nz-badge nzStatus="error">
          <small class="f-s-09r">Docments </small>
          </nz-badge>
        </a>
      </div>-->
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>
  <div *ngIf="state=='intimation'" class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>New Intimation</span>
        </div>
        <div>
          <!-- Mark as favourite -->
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">
      <div>
        <div class="grid grid-4x grid-gap-10 p-b-10">
          <div>
            <strong class="c-s-heading">Policy Number</strong>
            <nz-select nzShowSearch  [ngModel]="'0'">
              <nz-option [nzLabel]="'P9200199/JMSP'" [nzValue]="'0'"></nz-option>
              <nz-option [nzLabel]="'P8900218'" [nzValue]="'1'"></nz-option>
            </nz-select>
          </div>
          <div><strong class="c-s-heading">Intimation Date </strong> 10 May 2019</div>
          <div><strong class="c-s-heading">Status </strong> Draft</div>
          <div><strong class="c-s-heading">Event Type/Cause</strong> Death / Accident</div>
          <div><strong class="c-s-heading">Intimation Number </strong> -</div>
          <div><strong class="c-s-heading">Last Updated</strong> 10 May 2019, 10:15 am</div>
          <div><strong class="c-s-heading">Insured Name</strong> Chris Hemsworth</div>
          <div><strong class="c-s-heading">Event Date </strong> 5 May 2019</div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="Save to see progress" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="percentCompleted" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>

      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="workflowPanel(1,1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)"><i class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <!-- TO DISABLE an item, add .is-disabled -->
        <a class="is-disabled" (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> <span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i> Analytics</a>
      </div>
    </div>

  </div>
  <div *ngIf="state=='registration'" class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>New Registration</span>
        </div>
        <div>
          <!-- Mark as favourite -->
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">
      <div>
        <div class="grid grid-4x grid-gap-10 p-b-10">
          <div><strong class="c-s-heading">Policy Number</strong> <a (click)="policyPanel(1)">P9200199/JMSP</a></div>
          <div><strong class="c-s-heading">Claim Date </strong> 10 May 2019</div>
          <div><strong class="c-s-heading">Status </strong> Draft</div>
          <div><strong class="c-s-heading">Event Type/Cause</strong> Death / Accident</div>
          <div><strong class="c-s-heading">Claim Number </strong> CLM/MAY19/009883</div>
          <div><strong class="c-s-heading">Last Updated</strong> 10 May 2019, 10:15 am</div>
          <div><strong class="c-s-heading">Insured Name</strong> Chris Hemsworth</div>
          <div><strong class="c-s-heading">Event Date </strong> 5 May 2019</div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="70% complete" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="percentCompleted" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>

      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="workflowPanel(1,1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)"><i class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a class="is-disabled" (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> <span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i> Analytics</a>
      </div>
    </div>

  </div>
</div>
</div>


<div id="extras">
<!-- Frozen ? -->
<div class="m-t-20" *ngIf="caseIsFrozen">
  <span>
    <nz-alert nzType="error" nzCloseable nzMessage="This case is frozen. Unfreeze to resume work." nzShowIcon>
    </nz-alert>
  </span>
</div>

<!-- Pending Tasks ? -->
<div class="m-t-20" *ngIf="state=='adjudication' && productTypeConfig?.productType=='claims'">
  <span class="clickable" (click)="pendingPanel(1)">
    <nz-alert nzType="warning" nzCloseable nzMessage="2 ongoing tasks for this claim" nzShowIcon>
    </nz-alert>
  </span>
</div>

<!-- Comments -->
<div class="m-t-20" *ngIf="showLastComment">

  <div class="ant-alert ant-alert-info ant-alert-with-description">
    <i class="ant-alert-icon anticon anticon-read"></i>

    <span class="ant-alert-message">
          Note from <b>Ryan Reynolds [Adjudicator]</b>
        </span>
    <span class="ant-alert-description">
       <small class="d-b m-b-10">2 April 2019 at 3:30 PM (1 day ago)</small>
       Please verify document proofs submitted. Especially the bills from Sacred Hearts Hospital.
     </span>
    <div class="p-t-10 d-b">
      <a (click)="notesPanel(1)">View all Notes</a>
      &nbsp;
      <a (click)="showLastComment=false;">Close</a>
    </div>
  </div>
</div>
</div>

<!-- Tabs -->
<div id="tabs" class="m-t-20">

  <!-- CLAIMS TAB-SET -->
  <div *ngIf="productTypeConfig.productType=='claims'">
  <nz-tabset *ngIf="!!state"
    style="height:auto"
    [nzTabPosition]="nzTabPosition"
    [(nzSelectedIndex)]="selectedIndex"
    (nzSelectChange)="log([$event])"
  >

    <!-- INVESTIGATION -->
    <nz-tab *ngIf="permissions.investigation_report.show" [nzTitle]="titleTmplBasicInvest">
      <ng-template #titleTmplBasicInvest>
        <i nz-icon nzType="safety"></i> Investigation Report
      </ng-template>

      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

        <!-- Tabset for TWO INVESTIGATORS -->
        <nz-tabset style="height:auto" [nzSize]="'large'">

          <nz-tab [nzTitle]="titleTmplInvestigator1">
            <ng-template #titleTmplInvestigator1>
              <strong class="d-b">Investigator 2: Elliot Henderson (YOU!)</strong>
              <p class="col-grey-dark m-b-5">
                Investigation ongoing
              </p>
            </ng-template>
            <div>
              <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">
                <!-- Investigation Items -->

                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records</h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload
                              nzAction="https://jsonplaceholder.typicode.com/posts/"
                              nzListType="picture-card"
                              [(nzFileList)]="defaultUploadsList"
                              [nzShowButton]="defaultUploadsList.length < 3"
                              [nzShowUploadList]="showUploadList"
                      >
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>
                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate</h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload
                              nzAction="https://jsonplaceholder.typicode.com/posts/"
                              nzListType="picture-card"
                              [(nzFileList)]="defaultUploadsList"
                              [nzShowButton]="defaultUploadsList.length < 3"
                              [nzShowUploadList]="showUploadList"
                      >
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>

                <!-- Overall Summary -->

                <div class="heading-tab">
                  <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                </div>

                <div class="flexie-auto-grid">
                  <!-- Summary Textbox -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Summary</h3>
                    <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                  </div>
                  <!-- Summary : Final Verdict -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Verdict / Final Recommendation</h3>

                    <nz-radio-group [(ngModel)]="investiVerdict">
            <span class="d-b p-t-b-10">
              <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
            </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                      <span class="d-b p-t-b-10">
            <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
            </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                    </nz-radio-group>
                  </div>
                </div>

              </div>
            </div>
          </nz-tab>

          <nz-tab [nzTitle]="titleTmplInvestigator2">
            <ng-template #titleTmplInvestigator2>
              <strong class="d-b">Investigator 1: Kevin Fergie</strong>
              <p class="col-green m-b-5">
                Investigation Complete
              </p>
            </ng-template>
            <div class="inputs-are-disabled">
              <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">
                <!-- Investigation Items -->

                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records</h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload
                              nzAction="https://jsonplaceholder.typicode.com/posts/"
                              nzListType="picture-card"
                              [(nzFileList)]="defaultUploadsList"
                              [nzShowButton]="defaultUploadsList.length < 3"
                              [nzShowUploadList]="showUploadList"
                      >
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>
                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate</h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload
                              nzAction="https://jsonplaceholder.typicode.com/posts/"
                              nzListType="picture-card"
                              [(nzFileList)]="defaultUploadsList"
                              [nzShowButton]="defaultUploadsList.length < 3"
                              [nzShowUploadList]="showUploadList"
                      >
                        <i nz-icon nzType="plus"  nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>

                <!-- Overall Summary -->

                <div class="heading-tab">
                  <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                </div>

                <div class="flexie-auto-grid">
                  <!-- Summary Textbox -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Summary</h3>
                    <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                  </div>
                  <!-- Summary : Final Verdict -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Verdict / Final Recommendation</h3>

                    <nz-radio-group [(ngModel)]="investiVerdict">
            <span class="d-b p-t-b-10">
              <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
            </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                      <span class="d-b p-t-b-10">
            <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
            </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                    </nz-radio-group>
                  </div>
                </div>

              </div>
            </div>

          </nz-tab>

        </nz-tabset>

      </div>

    </nz-tab>

    <!-- BASIC DETAILS -->
    <nz-tab *ngIf="permissions.basic.show" [nzTitle]="titleTmplBasicDtl" (nzSelect)="log(['select', tab])"
            (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
      <ng-template #titleTmplBasicDtl>
        <i nz-icon nzType="file-text"></i> <nz-badge nzDot [nzDot]="hasTabBasicError">Basic Details</nz-badge>
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.basic.edit}">

      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-text"></i> Basic Details</h3>
      </div>

      <!-- Event Info. -->
      <div class="tab-grid m-t-20">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Event Type</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  [(ngModel)]="eventType" style="width: 100%">
              <nz-option [nzLabel]="'Death'" [nzValue]="'Death'"></nz-option>
              <nz-option [nzLabel]="'Critical Illness'" [nzValue]="'Critical Illness'"></nz-option>
              <nz-option [nzLabel]="'Hospital Cash and Surgical'" [nzValue]="'Hospital Cash and Surgical'"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Event Date <!--(Date of Death)--></nz-form-label>
          <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
            <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" [(ngModel)]="d1" (ngModelChange)="handleDateChangeD1($event)"></nz-date-picker>
            {{d1}}
          </nz-form-control>
          <small class="d-b">Retype Event Date</small>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" [(ngModel)]="d2" (ngModelChange)="handleDateChangeD2($event)"></nz-date-picker>
            {{d2}}
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Event Time <!--(Time of Death)--></nz-form-label>
          <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
            <nz-time-picker style="width:100%" [nzFormat]="'HH:mm'"></nz-time-picker>
          </nz-form-control>
          <small class="d-b">Retype Event Time</small>
          <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
            <nz-time-picker style="width:100%" [nzFormat]="'HH:mm'"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <!-- Cause of Death (only for Death case) -->
        <nz-form-item *ngIf="eventType=='Death'">
          <nz-form-label [nzSpan]="24">Cause of Death</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  [ngModel]="'Accident'" style="width: 100%">
              <nz-option [nzLabel]="'Accident'" [nzValue]="'Accident'"></nz-option>
              <nz-option [nzLabel]="'Natural'" [nzValue]="'Natural'"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Dates -->
      <div class="tab-grid m-t-0 hide">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Entry Date</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Received Date</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
            <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Intimation Date</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
            <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Claim details IF REGISTRATION -->
      <div *ngIf="state=='registration'" class="tab-grid m-t-20">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Claim Date</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Claim Time</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-time-picker style="width:100%" [nzFormat]="'HH:mm'"></nz-time-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Registration By</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  [ngModel]="'0'" style="width: 100%">
              <nz-option [nzLabel]="'Tim Cook'" [nzValue]="'0'"></nz-option>
              <nz-option [nzLabel]="'Rahul R'" [nzValue]="'1'"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

        <!-- POLICY/Policies -->
      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-protect" nzTheme="outline"></i> Policy</h3>
        <button *ngIf="state=='intimation'" nz-button nzType="primary" (click)="modSearchCustOrPolicy=true;">
          Search / Add
        </button>
      </div>
      <div class="search-results m-t-20">
        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th>Policy No</th>
            <th>Product</th>
            <th>Policy Status</th>
            <th>Premium Status</th>
            <th>Premium Paid Till</th>
            <th>Risk Commencement Date</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><a (click)="policyPanel(1)">P9200199/JMSP</a></td>
            <td>StandardLife</td>
            <td>Issued</td>
            <td>Paid</td>
            <td>20 Mar 2020</td>
            <td>20 Mar 2020</td>
            <td>
              <!-- Policy can be removed only at Intimation stage -->
              <a class="mutates-data does-delete" *ngIf="state=='intimation'" nz-popconfirm
              nzPopconfirmTitle="Remove Policy from intimation?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
            </td>
          </tr>
          <tr *ngIf="state=='intimation'"><!-- Show multiple policies only at Intimation stage -->
            <td><a (click)="policyPanel(1)">P9200199/JMSP/ADDON</a></td>
            <td>StandardLife</td>
            <td>Issued</td>
            <td>Paid</td>
            <td>20 Mar 2020</td>
            <td>20 Mar 2020</td>
            <td><a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove Policy from intimation?"
                   nzOkText="Remove" nzCancelText="Cancel">
              Remove</a></td>
          </tr>
          </tbody>
        </nz-table>
      </div>

      <!-- Police Station / FIR Details -->
      <div class="d-b m-t-20">
        <label nz-checkbox nzValue="true" [(ngModel)]="hasPoliceStnDetails">Add FIR/Police Station Details</label>
      </div>
      <div *ngIf="hasPoliceStnDetails" class="d-b m-t-20">
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="alert" nzTheme="outline"></i> Police Station Details</h3>
        </div>

        <div class="tab-grid m-t-20">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">FIR Number</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input value="MUM67/DDR/334/2019"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">FIR Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Address</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <textarea nz-input nzAutosize placeholder="Station's Address"></textarea>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Remarks</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <textarea nz-input nzAutosize placeholder="Add your remarks here"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      </div>

    </nz-tab>

    <!-- INSURED DETAILS -->
    <nz-tab *ngIf="permissions.insured.show" [nzTitle]="titleTmplLifeIns">
      <ng-template #titleTmplLifeIns>
        <i nz-icon nzType="heart"></i> Insured Details
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.insured.edit}">

      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-protect" nzTheme="outline"></i> Insured</h3>
        <button nz-button nzType="primary" (click)="modalSearchCustomer(true)">Search / Add Insured</button>
      </div>

      <div class="search-results m-t-20">
        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th *ngIf="state=='intimation'"></th>
            <th>Customer No</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>DOB</th>
            <th>Gender</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td *ngIf="state=='intimation'"><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
            <td><a (click)="profilePanel(1)">C000593</a></td>
            <td>Chris</td>
            <td>Hemsworth</td>
            <td>17 Nov 1958</td>
            <td>M</td>
          </tr>
          <tr *ngIf="state=='intimation'"> <!-- Show multiple only in case of new Intimation -->
            <td><label nz-checkbox nzValue="B" [ngModel]="false"></label></td>
            <td><a (click)="profilePanel(1)">C0010982</a></td>
            <td>Liam</td>
            <td>Hemsworth</td>
            <td>28 April 1978</td>
            <td>M</td>
          </tr>
          </tbody>
        </nz-table>
      </div>
      </div>

    </nz-tab>

    <!-- NOMINEE & CLAIMANT DETAILS -->
    <nz-tab *ngIf="permissions.nominee_claimant.show" [nzTitle]="titleTmplClaimant">
      <ng-template #titleTmplClaimant>
        <i nz-icon nzType="team"></i> Nominee/Claimant Details
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.nominee_claimant.edit}">

      <!-- Nominee -->
      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Nominee</h3>
        <button nz-button nzType="primary" (click)="modalSearchCustomer(true)">Search / Add Nominee</button>
      </div>
      <div class="search-results m-t-20">
        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th>Payee</th>
            <th>Customer No</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>DOB</th>
            <th>Gender</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><label nz-checkbox nzValue="true" [ngModel]="true"></label></td>
            <td><a (click)="profilePanel(1)">C001982</a></td>
            <td>Liam</td>
            <td>Hemsworth</td>
            <td>26 April 1969</td>
            <td>M</td>
            <td>
              <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a> |
              <a class="mutates-data does-edit"
                 nz-popconfirm nzPopconfirmTitle="Remove customer from intimation?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>

      <!-- Claimant -->
      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Claimant</h3>
        <div *ngIf="state=='intimation' || state=='registration'">
          <!-- SAME AS ABOVE ? -->
          <label nz-checkbox nzValue="true" [(ngModel)]="claimantSameAsNominee">
            Claimant same as Nominee
          </label>
          <button *ngIf="!claimantSameAsNominee" nz-button nzType="primary"
                  (click)="modalSearchCustomer(true,false)">Search / Add Claimant</button>
          <button *ngIf="claimantSameAsNominee" disabled nz-button nzType="primary">Search / Add Claimant</button>
        </div>
      </div>
      <div class="search-results m-t-20">


        <!-- Table -->
        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th>Customer No</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>DOB</th>
            <th>Gender</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><a (click)="profilePanel(1)">C001982</a></td>
            <td>Liam</td>
            <td>Hemsworth</td>
            <td>26 April 1969</td>
            <td>M</td>
            <td>
              <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a>
              <!-- Remove Claimant shoud be enabled only for Intimation -->
              <span *ngIf="state=='intimation'"> |
              <a class="mutates-data does-edit" nz-popconfirm nzPopconfirmTitle="Remove customer from intimation?"
                 nzOkText="Remove" nzCancelText="Cancel">Remove</a>
              </span>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>

      </div>

    </nz-tab>

    <!-- HOSPITALIZATION DETAILS -->
    <nz-tab *ngIf="permissions.hospitalization.show" [nzTitle]="titleTmplHospital">
      <!-- Heading -->
      <ng-template #titleTmplHospital>
        <i nz-icon nzType="medicine-box"></i> Hospitalization Details
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.hospitalization.edit}">

      <!-- LIFE CLAIM -->
      <div *ngIf="'claims-life'==productType">
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="medicine-box" nzTheme="outline"></i> Hospitalization Details</h3>
          <button nz-button nzType="primary" (click)="modHospitalizationDetails=true">Add Hospitalization Details</button>
        </div>
        <!-- Nested Table -->
        <app-ui-nested-table></app-ui-nested-table>
      </div>

      <!-- HEALTH CLAIM -->
      <app-ui-hospitalization-simple-tab *ngIf="'claims-health'==productType"></app-ui-hospitalization-simple-tab>

      </div>
    </nz-tab>



    <!-- BANK DETAILS -->
    <nz-tab *ngIf="permissions.bank_details.show" [nzTitle]="titleTmplBank">
      <ng-template #titleTmplBank>
        <i nz-icon nzType="bank"></i> Bank Details
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.bank_details.edit}">

        <h3 class="heading">Bank Details for Nominee(s)</h3>

        <!-- TABSET for NOMINEE DETAILS -->
        <nz-tabset style="height:auto" [nzSize]="'large'">
          <nz-tab [nzTitle]="titleTmplBankNominee1">
            <ng-template #titleTmplBankNominee1>
              <strong class="d-b">Nominee 1: Liam Hemsworth</strong>
              <p class="col-green m-b-5">
                <!--<i nz-icon nzType="check" nzTheme="outline" class="m-r-5"></i>-->
                Bank details added
              </p>
            </ng-template>

            <!-- FORM -->
            <app-ui-bank-account-details forWhom="Nominee 1: Liam Hemsworth"></app-ui-bank-account-details>

          </nz-tab>
          <nz-tab [nzTitle]="titleTmplBankNominee2">
            <ng-template #titleTmplBankNominee2>
              <strong class="d-b">Nominee 2: Mark Hemsworth</strong>
              <p class="col-grey-dark m-b-5">
                <!--<i nz-icon nzType="close" nzTheme="outline" class="m-r-5"></i>-->
                Bank details not added
              </p>
            </ng-template>

            <!-- FORM -->
            <app-ui-bank-account-details forWhom="Nominee 2: Mark Hemsworth"></app-ui-bank-account-details>

          </nz-tab>
        </nz-tabset>

      </div>

    </nz-tab>

    <!-- PAYOUT DETAILS -->
    <nz-tab *ngIf="permissions.payout_details.show" [nzTitle]="titleTmplPayoutDetails">
    <ng-template #titleTmplPayoutDetails>
      <i nz-icon nzType="dollar"></i> Payout Details
    </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.payout_details.edit}">

      <div class="flexie-auto-grid">
        <!-- Credit -->
        <div>
          <h2 class="col-green text-a-center f-s-1-5r p-b-20"><i nz-icon nzType="dollar"></i> Credit</h2>
          <div class="grid grid-gap-10 grid-2x p-r-20" style="border-right:1px dashed #999">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Outstanding Premium</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Penalty</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Premium Suspense</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Total Premium Paid</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <!-- Debit -->
        <div class="p-l-0">
          <h2 class="col-red text-a-center f-s-1-5r p-b-20"><i nz-icon nzType="dollar"></i> Debit</h2>
          <div class="grid grid-gap-10 grid-2x">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Benefit Amount</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Advance Premium</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Interest</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input/></nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      <!--<div class="tab-grid"></div>-->
      </div>

    </nz-tab>

    <!-- BILL DETAILS (HEALTH CLAIM) -->
    <nz-tab *ngIf="productType=='claims-health' && permissions.bill_details.show" [nzTitle]="titleTmplBillDetails">
    <ng-template #titleTmplBillDetails>
      <i nz-icon nzType="profile"></i> Bill Details
    </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.bill_details.edit}">

        <app-ui-bill-details></app-ui-bill-details>

      </div>

    </nz-tab>

    <!-- BENEFIT -->
    <nz-tab *ngIf="permissions.benefit.show" [nzTitle]="titleTmplBenefit">
      <ng-template #titleTmplBenefit>
        <i nz-icon nzType="wallet"></i> Benefit
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.benefit.edit}">
        <div class="list-benefits">

          <nz-table class="valign-top" [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x:'1200px'}">
            <thead>
            <tr>
              <th>Cover Name</th>
              <th>Benefit</th>
              <th>Event</th>
              <th>Benefit Amount</th>
              <th>Approved Amount</th>
              <th>Decision</th>
              <th>Notes</th>
            </tr>
            </thead>
            <tbody class="valign-top">
            <tr class="v-a-top">
              <td>StandardLife</td>
              <td>Hospitalization Coverage</td>
              <td>Hospitalization</td>
              <td>Rs. 250,000</td>
              <td>
                <nz-input-group nzAddOnBefore="Rs.">
                  <input nz-input placeholder="Enter Amount" nzSize="large"
                         [(ngModel)]="tempBenefit1" (ngModelChange)="updateBenefitTotal()"/>
                </nz-input-group>
              </td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Approve'" style="width: 100%">
                  <nz-option [nzLabel]="'Approve'" [nzValue]="'Approve'"></nz-option>
                  <nz-option [nzLabel]="'Reject'" [nzValue]="'Reject'"></nz-option>
                </nz-select>
              </td>
              <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Hospitalization Coverage Benefit"></textarea></td>
            </tr>
            <tr class="v-a-top">
              <td>StandardLife</td>
              <td>Ambulance Costs</td>
              <td>Hospitalization</td>
              <td>Rs. 20,000</td>
              <td>
                <nz-input-group nzAddOnBefore="Rs.">
                  <input nz-input placeholder="Enter Amount" nzSize="large"
                         [(ngModel)]="tempBenefit2" (ngModelChange)="updateBenefitTotal()"/>
                </nz-input-group>
              </td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Approve'" style="width: 100%">
                  <nz-option [nzLabel]="'Approve'" [nzValue]="'Approve'"></nz-option>
                  <nz-option [nzLabel]="'Reject'" [nzValue]="'Reject'"></nz-option>
                </nz-select>
              </td>
              <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Ambulance Costs Benefit"></textarea></td>
            </tr>
            <tr class="v-a-top">
              <td>StandardLife</td>
              <td>Critical Illness</td>
              <td>Critical Illness</td>
              <td>Rs. 3,50,000</td>
              <td>
                <nz-input-group nzAddOnBefore="Rs.">
                  <input nz-input placeholder="Enter Amount" nzSize="large"
                         [(ngModel)]="tempBenefit3" (ngModelChange)="updateBenefitTotal()"/>
                </nz-input-group>
              </td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Approve'" style="width: 100%">
                  <nz-option [nzLabel]="'Approve'" [nzValue]="'Approve'"></nz-option>
                  <nz-option [nzLabel]="'Reject'" [nzValue]="'Reject'"></nz-option>
                </nz-select>
              </td>
              <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Critical Illness Benefit"></textarea></td>
            </tr>
            <tr class="v-a-top">
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td><span class="f-w-600">Total Approved</span></td>
              <td>
                  <span class="f-s-1-7r col-red">
                    Rs.
                  <span [(countUp)]="tempBenefitTotal" [reanimateOnClick]="false">
                  </span>
                  </span>
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            </tbody>
          </nz-table>

        </div>
      </div>

    </nz-tab>

    <!-- PAYMENT BREAKUP  -->
    <nz-tab *ngIf="permissions.payment_breakup.show" [nzTitle]="titleTmplPayout">
      <ng-template #titleTmplPayout>
        <i nz-icon nzType="audit"></i> Payment Breakup
      </ng-template>

      <div class="payment-breakup"
           [ngClass]="{'inputs-are-disabled': !permissions.payment_breakup.edit}"
           style="display:grid; grid-gap: 20px; grid-template-columns: 60% auto;">

        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th>#</th>
            <th>Transaction</th>
            <th>CR/DR</th>
            <th>Type</th>
            <th>Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>1</td>
            <td>Total Claim</td>
            <td>DR</td>
            <td>Lump Sum</td>
            <td>
              <span class="col-red">{{tempBenefitTotal}}</span>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>Advance Premium</td>
            <td>CR</td>
            <td>Staggered</td>
            <td>
              <span class="col-green">{{advancePremium}}</span>
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>Outstanding Premium</td>
            <td>CR</td>
            <td>Staggered</td>
            <td>
              <span class="col-green">{{outstandingPremium}}</span>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>Total</td>
            <td>
              <span class="f-s-1-7r col-red">
                Rs.
                <span [(countUp)]="totalPayoutAmt" [reanimateOnClick]="false">
                </span>
              </span>
            </td>
          </tr>
          </tbody>
        </nz-table>

        <div class="grid grid-gap-20">
          <nz-card *ngFor="let i of [1,2]">

            <!-- Heading -->
            <div class="grid grid-2x grid-gap-20 m-t-b-10">
              <div>
                <strong class="d-b"><small class="d-b col-grey">
                  Nominee {{i}}:</small> Liam Hemsworth
                </strong>
                <small class="d-b col-green">
                  <i nz-icon nzType="check" nzTheme="outline"></i> Bank details added
                </small>
              </div>
              <div>
                <small class="d-b">Sharing Percentage</small>
                <nz-input-group nzAddOnAfter="%">
                  <input nz-input placeholder="Enter Percentage" nzSize="large" ngModel="50"/>
                  <!-- [(ngModel)]="payoutNom1" (ngModelChange)="updatePayoutNominee()" -->
                </nz-input-group>
              </div>
            </div>

            <!-- Form -->
            <div class="grid grid-2x grid-gap-20 m-t-b-10">
              <div>
                <small class="d-b">Benefit amount</small>
                <nz-input-group nzAddOnBefore="Rs.">
                  <input nz-input placeholder="Enter Amount" nzSize="large" ngModel="1,00,000" [disabled]="true"/>
                  <!-- [(ngModel)]="payoutNom1" (ngModelChange)="updatePayoutNominee()" -->
                </nz-input-group>
              </div>
              <div>
                <small class="d-b">Payout</small>
                <nz-select nzShowSearch  [ngModel]="'1'" style="width: 100%">
                  <nz-option [nzLabel]="'One Time'" [nzValue]="'1'"></nz-option>
                  <nz-option [nzLabel]="'Periodic'" [nzValue]="'0'"></nz-option>
                </nz-select>
              </div>
            </div>
            <div class="d-b m-t-b-10">
              <label nz-checkbox nzValue="true" [ngModel]="true">Approve Payment</label>
            </div>
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <textarea nz-input cols="30" rows="3" placeholder="Remarks ..."></textarea>
              </nz-form-control>
            </nz-form-item>
          </nz-card>
        </div>

      </div>

    </nz-tab>

    <!-- CLAIM Decision -->
    <nz-tab *ngIf="permissions.adj_claim_decision.show" [nzTitle]="titleTmplDecision">
      <ng-template #titleTmplDecision>
        <i nz-icon nzType="exception"></i> Claim Decision
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.adj_claim_decision.edit}">
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="file-text"></i> Claim Decision</h3>
        </div>
        <div class="tab-grid m-t-20">
          <!-- Decision -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Decision</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  [ngModel]="'Approve'" style="width: 100%">
                <nz-option [nzLabel]="'Approve'" [nzValue]="'Approve'"></nz-option>
                <nz-option [nzLabel]="'Reject'" [nzValue]="'Reject'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <!-- Notes -->
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Notes/Findings</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <textarea nz-input cols="30" rows="4" placeholder="Enter your notes ..."></textarea>
              </nz-form-control>
          </nz-form-item>
        </div>

        <!-- CLAIM RULES -->
        <div>
          <nz-collapse [nzBordered]="true">
            <nz-collapse-panel [nzHeader]="'Claim Rules'" [ngStyle]="{}" [nzActive]="true">
              <app-ui-rules-auto></app-ui-rules-auto>
            </nz-collapse-panel>
          </nz-collapse>
        </div>

      </div>

    </nz-tab>

    <!-- OTHER POLICY DETAILS -->
    <nz-tab *ngIf="permissions.other_policies.show" [nzTitle]="titleTmplOtherPoli">
      <ng-template #titleTmplOtherPoli>
        <i nz-icon nzType="security-scan"></i> Other Policy Details
      </ng-template>
      <nz-table>
        <thead>
        <tr>
          <th>Name of Life Insurance Company</th>
          <th>Policy Number</th>
          <th>Address</th>
          <th>Commencement Date</th>
          <th>Coverage Amount (Rs.)</th>
          <th>Claim Submitted</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </nz-table>
    </nz-tab>
    <!-- -->

    <!-- ANALYTICS -->
    <nz-tab *ngIf="permissions.analytics.show" [nzTitle]="titleTmplAnltix">
      <ng-template #titleTmplAnltix>
        <i nz-icon nzType="dot-chart"></i> Analytics
      </ng-template>

      <div
          [ngClass]="{'inputs-are-disabled': !permissions.analytics.edit}">
      <!-- ensure 'tab' mode -->
      <!-- <app-ui-analytics-tab mode="tab"></app-ui-analytics-tab> -->
      </div>

    </nz-tab>
    <!-- -->

  </nz-tabset>
  </div>

  <!-- UNDERWRITING TAB-SET -->
  <div *ngIf="productTypeConfig.productType=='underwriting'">
  <nz-tabset style="height:auto"
             [nzTabPosition]="nzTabPosition"
             [(nzSelectedIndex)]="selectedIndex"
             (nzSelectChange)="log([$event])"
  >
    <!-- PLAN -->
    <nz-tab *ngIf="permissions.uw_plan.show" [nzTitle]="titleTmplPlan">
      <ng-template #titleTmplPlan><i nz-icon nzType="file-protect"></i> Plan </ng-template>
      <div [ngClass]="{'inputs-are-disabled': !permissions.uw_plan.edit}">

        <!-- Dates -->
        <div class="tab-grid m-t-20">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Product</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  [ngModel]="0" style="width: 100%">
                <nz-option [nzLabel]="'StandardHealth'" [nzValue]="0"></nz-option>
                <nz-option [nzLabel]="'FamilyHealth'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'FamilyHealth PRO'" [nzValue]="1"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Currency</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  [ngModel]="0" style="width: 100%">
                <nz-option [nzLabel]="'INR'" [nzValue]="0"></nz-option>
                <nz-option [nzLabel]="'USD'" [nzValue]="1"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  [ngModel]="0" style="width: 100%">
                <nz-option [nzLabel]="'Protection'" [nzValue]="0"></nz-option>
                <nz-option [nzLabel]="'Credit Score'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'Safety & Convenience'" [nzValue]="2"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Sum Insured</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-input-group [nzAddOnBefore]="'Rs.'"><input type="text" nz-input [(ngModel)]="sumInsured"/></nz-input-group>

            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Entry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Received Date</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Signed Date</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Inception Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Expiry  Date</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Due Date</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
              <nz-date-picker nzShowTime [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

      </div>
    </nz-tab>

    <!-- MEMBERS -->
    <nz-tab *ngIf="permissions.uw_members.show" [nzTitle]="titleTmplMemb">
      <ng-template #titleTmplMemb><i nz-icon nzType="team"></i> Members </ng-template>
      <div [ngClass]="{'inputs-are-disabled': !permissions.uw_members.edit}">

        <!-- Primary Insured -->
        <div>
          <div class="heading-tab">
            <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Primary Insured</h3>
            <button nz-button nzType="primary" (click)="modalSearchCustomer(true)">Search / Add Primary Insured</button>
          </div>
          <div class="search-results m-t-20">
            <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x:'1200px'}">
              <thead>
              <tr>
                <th>Customer No</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><a (click)="profilePanel(1)">C00M1856</a></td>
                <td>Chris</td>
                <td>Hemsworth</td>
                <td>08 Jul 1957</td>
                <td>Male</td>
                <td>
                  <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a> |
                  <a class="mutates-data does-edit"
                     nz-popconfirm nzPopconfirmTitle="Remove customer from members list?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
                </td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </div>

        <!-- Members -->
        <div>
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Members <small>(upto 4 members: 2 Adults, 2 Children)</small></h3>
          <button nz-button nzType="primary" (click)="modalSearchCustomer(true)">Search / Add Members</button>
        </div>
        <div class="search-results m-t-20">
          <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x:'1200px'}">
            <thead>
            <tr>
              <th>Customer No</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>DOB</th>
              <th>Gender</th>
              <th style="width:300px;">Relationship with Primary Insured</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><a (click)="profilePanel(1)">C00F1982</a></td>
              <td>Rachel</td>
              <td>Hemsworth</td>
              <td>26 Apr 1969</td>
              <td>Female</td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Spouse'" style="width: 100%">
                  <nz-option [nzLabel]="'Spouse'" [nzValue]="'Spouse'"></nz-option>
                  <nz-option [nzLabel]="'Other'" [nzValue]="'Other'"></nz-option>
                </nz-select>
              </td>
              <td>
                <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a> |
                <a class="mutates-data does-edit"
                   nz-popconfirm nzPopconfirmTitle="Remove customer from members list?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
              </td>
            </tr>
            <tr>
              <td><a (click)="profilePanel(1)">C00M1992</a></td>
              <td>Liam</td>
              <td>Hemsworth</td>
              <td>03 Jun 1988</td>
              <td>Male</td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Other'" style="width: 100%">
                  <nz-option [nzLabel]="'Spouse'" [nzValue]="'Spouse'"></nz-option>
                  <nz-option [nzLabel]="'Other'" [nzValue]="'Other'"></nz-option>
                </nz-select>
              </td>
              <td>
                <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a> |
                <a class="mutates-data does-edit"
                   nz-popconfirm nzPopconfirmTitle="Remove customer from members list?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
              </td>
            </tr>
            <tr>
              <td><a (click)="profilePanel(1)">C00M1999</a></td>
              <td>Luke</td>
              <td>Hemsworth</td>
              <td>17 May 1992</td>
              <td>Male</td>
              <td>
                <nz-select nzShowSearch  [ngModel]="'Other'" style="width: 100%">
                  <nz-option [nzLabel]="'Spouse'" [nzValue]="'Spouse'"></nz-option>
                  <nz-option [nzLabel]="'Other'" [nzValue]="'Other'"></nz-option>
                </nz-select>
              </td>
              <td>
                <a class="mutates-data does-edit" (click)="editCustomerDetails()">Edit</a> |
                <a class="mutates-data does-edit"
                   nz-popconfirm nzPopconfirmTitle="Remove customer from members list?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
              </td>
            </tr>
            </tbody>
          </nz-table>
        </div>
        </div>

      </div>
    </nz-tab>

    <!-- Coverages -->
    <nz-tab *ngIf="permissions.uw_coverages.show" [nzTitle]="titleTmplCoverages">
      <ng-template #titleTmplCoverages><i nz-icon nzType="carry-out"></i> Coverages </ng-template>
      <div [ngClass]="{'inputs-are-disabled': !permissions.uw_coverages.edit}">
        <div class="inputs-are-disabled">
          <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Base Plan Cover</h3>
          <app-ui-coverages-health [sumInsured]="sumInsured"></app-ui-coverages-health>
        </div>
        <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Additional Cover</h3>
        <app-ui-coverages-health [sumInsured]="sumInsured" [addRows]="2"></app-ui-coverages-health>
      </div>
    </nz-tab>

    <!-- RULES -->
    <nz-tab *ngIf="permissions.uw_auto_rules.show" [nzTitle]="titleTmplQuest">

      <ng-template #titleTmplQuest><i nz-icon nzType="issues-close"></i> Auto Rules </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.uw_auto_rules.edit}">
        <app-ui-rules-auto></app-ui-rules-auto>
      </div>
    </nz-tab>

    <!-- QUESTIONNAIRE -->
    <nz-tab *ngIf="permissions.uw_questionnaire.show" [nzTitle]="titleTmplQuest">

      <ng-template #titleTmplQuest><i nz-icon nzType="question-circle"></i> Questionnaire </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.uw_questionnaire.edit}">
        <app-ui-questionnaire></app-ui-questionnaire>
      </div>
    </nz-tab>

  </nz-tabset>
  </div>

</div>

<!-- Save/Actions Footer -->
<div *ngIf="productTypeConfig.productType=='claims'">
  <!-- Save/Actions Footer for INTIMATION / REGISTRATION cases -->
  <div *ngIf="state=='intimation' || state == 'registration'" class="card-summary-data-footer __data-footer-primary">
    <div>
      <button nz-button [nzType]="'danger'" (click)="modRejectIntimation=true;">Reject {{stateName}}</button>
    </div>
    <div>
      <button nz-button class="m-r-10" [nzType]="'success'">Submit</button>
      <!-- Save button on click enables dummy ERROR state to display error handling UI/UX-->
      <button nz-button class="m-r-10" [nzType]="'primary'" (click)="setErrorState(true)">Save</button>
    </div>
  </div>
  <!-- Save/Actions Footer for other cases -->
  <div *ngIf="state!=='intimation' && state!== 'registration'"
       class="card-summary-data-footer __data-footer-primary">
    <div>
      <nz-dropdown-menu class="m-r-10">
        <button nz-button [nzType]="'danger'" nz-dropdown>Reverse Claim<i nz-icon nzType="down"></i></button>
        <ul nz-menu>
          <li nz-menu-item (click)="showConfirm('Intimation')">
            <a>Reverse to Intimation</a>
          </li>
          <li nz-menu-item (click)="showConfirm('Registration')">
            <a>Reverse to Registration</a>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <div>

      <button nz-button class="m-r-10" [nzType]="'danger'">Reject</button>
      <nz-dropdown-menu class="m-r-10">
        <button nz-button nz-dropdown>Actions<i nz-icon nzType="down"></i></button>
        <ul nz-menu>
          <li nz-menu-item (click)="modSubmit=true"><a>Submit</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Assign Investigator</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to Underwriter</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to CMO</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to Re-Insurer</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to Legal</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to Compliance</a></li>
          <li nz-menu-item (click)="modInvtgVis=true"><a>Refer to Claims Committee</a></li>
          <li nz-menu-item><a>Back to Adjudicator</a></li>
          <li nz-menu-item><a>Back to Registration</a></li>
          <li nz-menu-item><a>Back to Intimation</a></li>
        </ul>
      </nz-dropdown-menu>
      <button nz-button class="m-r-10" [nzType]="'primary'" (click)="setErrorState(true)">Save</button>
    </div>
  </div>
</div>
<div *ngIf="productTypeConfig.productType=='underwriting'">
  <div class="card-summary-data-footer __data-footer-primary">
    <div>
      <!-- LHS -->
    </div>
    <div>
      <button nz-button class="m-r-10" [nzType]="'success'">Submit</button>
      <button nz-button class="m-r-10" [nzType]="'primary'" (click)="setErrorState(true)">Save</button>
    </div>
  </div>
</div>


<!-- Has Errors / Show Errors ? -->
<div *ngIf="hasServerExceptions" class="error-panel"
     [ngClass]="{'error-panel-collapsed': errPanelCollapsed}"
>

  <!-- Heading -->
  <div class="flexie-auto-grid clickable p-b-5" (click)="errorPanelToggle()">
    <div>
      <h4 class="col-red">Exceptions</h4>
    </div>
    <div class="text-a-right d-b">
      <i *ngIf="!errPanelCollapsed" class="anticon anticon-down"></i>
      <i *ngIf="errPanelCollapsed"  class="anticon anticon-up"></i>
    </div>
  </div>

  <!-- Errors List -->
  <div>
    <strong class="col-grey-dark">Basic Details</strong>
    <ul class="error-list">
      <li>
        <span>`Event Date` is required</span> &bull; <a (click)="errJumpTo(0,'eventDate')">View</a>
      </li>
      <li>
        <span>`Event Time` is required</span> &bull; <a (click)="errJumpTo(0,'eventDate')">View</a>
      </li>
    </ul>

    <strong class="col-grey-dark">Bank Details</strong>
    <ul class="error-list">
      <li>
        <span class="">`IFSC Code` is invalid</span> &bull; <a (click)="errJumpTo(4,'ifscCode')">View</a>
        <br><label nz-checkbox nzValue="true" ngModel="true">Override</label> (Manager+)
      </li>
    </ul>
  </div>

  <!-- View all -->
  <a (click)="errDetailsPanel(1)" class="d-b col-grey-dark p-t-b-5 b-1 text-a-center">View All</a>

</div>


<!-- =======================================================================================================  -->
<!-- FORM ENDED  -->
<!-- =======================================================================================================  -->

<!-- MODALS -->

<nz-modal nzMaskClosable="false" [(nzVisible)]="modInvtgVis"
          nzTitle="Assign Investigator"
          (nzOnCancel)="modInvtgVis=false" (nzOnOk)="modInvtgVis=false"
          nzOkText="Refer"
          nzWidth="600px"
>
  <div *ngIf="modInvtgVis">

    <div class="flex flex-horiz-space-bw">
      <h4>Enter your Notes</h4>
      <nz-dropdown-menu>
        <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
        <ul nz-menu>
          <li nz-menu-item (click)="noteCannedReply(0)">Please have a look at the ...</li>
          <li nz-menu-item (click)="noteCannedReply(1)">Requesting additional investigation ...</li>
          <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
          <nz-divider class="dd-extra-hr"></nz-divider>
          <li nz-menu-item (click)="cannedModal=true">Manage Canned Replies</li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <textarea rows="2" nz-input [(ngModel)]="note"></textarea>

    <h4 class="d-b m-t-20">Investigate</h4>
    <nz-select nzShowSearch  nzMode="tags" style="width: 100%;" [ngModel]="'Hospital Records'">
      <nz-option nzLabel="Hospital Records" nzValue="Hospital Records"> </nz-option>
      <nz-option nzLabel="Death Certificate" nzValue="Death Certificate"> </nz-option>
      <nz-option nzLabel="Cross-check with Doctor" nzValue="Cross-check with Doctor"> </nz-option>
    </nz-select>


    <div class="flex flex-horiz-space-bw m-t-20">
      <h4>Attach Files/Documents</h4>
      <a (click)="docuPanel(1)">Attach</a>
    </div>

    <!-- Upload table -->
    <nz-table [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{x:'700px'}">
      <thead>
      <tr>
        <th>Type</th>
        <th>Comment</th>
        <th>Document</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Claim Form</td>
        <td>Please check this in detail</td>
        <td><a>SCAN_DCertificate_0023092019.pdf</a></td>
        <td>
          <!-- Actions -->
          <span><i class="anticon anticon-delete col-red"></i></span>
        </td>
      </tr>
      </tbody>
    </nz-table>

    <h4 class="d-b m-t-20">Assign to</h4>
    <nz-select nzShowSearch  class="w-100-pc"  nzAllowClear nzPlaceHolder="Select a person">
      <nz-option nzLabel="Jack Nicholson (Golden Bay Area)" nzValue="1"></nz-option>
      <nz-option nzLabel="Lucy Liu (Hypercity Area)" nzValue="2"></nz-option>
      <nz-option nzLabel="Tom Hardy (New Delhi Area)" nzValue="3"></nz-option>
    </nz-select>
  </div>

</nz-modal>

<nz-modal nzMaskClosable="false" [(nzVisible)]="modalCorrespNew"
          nzTitle="New Correspondence"
          (nzOnCancel)="modalCorrespNew=false" (nzOnOk)="modalCorrespNew=false"
          nzOkText="Send"
          nzWidth="75%" nzZIndex="4"
>
  <div *ngIf="modalCorrespNew">

    <nz-radio-group [(ngModel)]="correspType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
      <label nz-radio-button nzValue="email"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
      <label nz-radio-button nzValue="sms"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
      <label nz-radio-button nzValue="pdf"><i nz-icon nzType="file-pdf" nzTheme="outline"></i> PDF</label>
    </nz-radio-group>

    <div *ngIf="'email'==correspType">
    <h4 class="d-b m-t-20">To</h4>
      <!-- Multi emails; ENTER to add new entry -->
      <nz-select nzShowSearch  nzMode="tags" style="width: 100%;" [ngModel]="'liam@thehemsworths.com'">
        <nz-option nzLabel="liam@thehemsworths.com" nzValue="liam@thehemsworths.com"></nz-option>
        <nz-option nzLabel="chris@thehemsworths.com" nzValue="chris@thehemsworths.com"></nz-option>
        <nz-option nzLabel="robert@thehemsworths.com" nzValue="robert@thehemsworths.com"></nz-option>
      </nz-select>

    <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
      <div class="flexie-auto-grid">
        <div>
          <small class="d-b text-a-left col-dark">Select replacement</small>
          <nz-select nzShowSearch  style="width:100%" [(ngModel)]="replacementSelected" (ngModelChange)="replacementSelect(replacementSelected.value)">
            <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
          </nz-select>
        </div>
        <div>
          <small class="d-b text-a-left col-dark">Copy-paste code</small>
          <!-- One-way bound ! -->
          <input type="text" nz-input [ngModel]="replacementSelected" name="replacement"
                 #selectionInput (click)="selectionInput.select()" />
        </div>
      </div>
      <div>
        <small class="d-b text-a-right col-dark">Template</small>
        <nz-select nzShowSearch  [ngModel]="'Document Missing - Death Certificate'">
          <nz-option nzLabel="Document Missing - Death Certificate"
                     nzValue="Document Missing - Death Certificate"></nz-option>
          <nz-option nzLabel="Document Missing - Medical Records"
                     nzValue="Document Missing - Medical Records"></nz-option>
        </nz-select>
      </div>
    </div>

    <h4 class="d-b">Subject</h4>
    <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceSubject">

    <h4 class="d-b m-t-20">Content</h4>

    <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>
    <!-- HTML content -->
    <!--<pre>{{correspondenceRichText}}</pre>-->

    <!-- Attach / Upload -- >
    <h4 class="d-b m-t-20">Attach Files/Documents</h4>
    <nz-upload
      nzType="drag"
      [nzMultiple]="true"
      [nzLimit]="2"
      nzAction="https://jsonplaceholder.typicode.com/posts/"
      (nzChange)="handleFileUpload($event)">
      <p class="ant-upload-drag-icon">
        <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
      </p>
      <p class="ant-upload-text">Click or drag file to this area to upload</p>
      <p class="ant-upload-hint">
        Single file & bulk upload supported. Strictly prohibited from uploading internal company data or other confidential data
      </p>
    </nz-upload>
    < !-- -->


    </div>

    <div *ngIf="'pdf'==correspType">
      <h4 class="d-b m-t-20">Content</h4>
      <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
        <div class="flexie-auto-grid">
          <div>
            <small class="d-b text-a-left col-dark">Select replacement</small>
            <nz-select nzShowSearch  style="width:100%" [(ngModel)]="replacementSelected" (ngModelChange)="replacementSelect(replacementSelected.value)">
              <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
            </nz-select>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Copy-paste code</small>
            <!-- One-way bound ! -->
            <input type="text" nz-input [ngModel]="replacementSelected" name="replacement"
                   #selectionInput (click)="selectionInput.select()" />
          </div>
        </div>
        <div>
          <small class="d-b text-a-right col-dark">Template</small>
          <nz-select nzShowSearch  [ngModel]="'Document Missing - Death Certificate'">
            <nz-option nzLabel="Document Missing - Death Certificate"
                       nzValue="Document Missing - Death Certificate"></nz-option>
            <nz-option nzLabel="Document Missing - Medical Records"
                       nzValue="Document Missing - Medical Records"></nz-option>
          </nz-select>
        </div>
      </div>
      <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>
    </div>

    <div *ngIf="'sms'==correspType">
      <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
      <!-- Multi phone nos; ENTER to add new entry -->
      <nz-select nzShowSearch  nzMode="tags" style="width: 100%;" [ngModel]="'9800560098'">
        <nz-option nzLabel="9800560098" nzValue="9800560098"> </nz-option>
      </nz-select>
      <h4 class="d-b m-t-20">Message</h4>
      <textarea nz-input value=""></textarea>
    </div>

  </div>

</nz-modal>

<nz-modal nzMaskClosable="false" [(nzVisible)]="modSubmit"
          nzTitle="Submit"
          (nzOnCancel)="modSubmit=false" (nzOnOk)="modSubmit=false"
          nzOkText="Submit"
>
  <div *ngIf="modSubmit">

    <h4>I have verified</h4>
    <span class="d-b p-t-b-10"><label nz-checkbox>Documents are in place</label></span>
    <span class="d-b p-t-b-10"><label nz-checkbox>Proofs matches with records</label></span>
    <span class="d-b p-t-b-10"><label nz-checkbox>Verified against discrepancies in claim</label></span>
    <span class="d-b p-t-b-10"><label nz-checkbox>Verified claim amount</label></span>

    <div class="m-t-20">
      <h4 class="d-i-b m-r-10">Logged in as</h4>
      <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
      John Doe
    </div>

  </div>

</nz-modal>

<!-- Search Policy or Customer -->
<nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchCustOrPolicy"
          nzTitle="Search / Add Policy"
          (nzOnCancel)="modSearchCustOrPolicy=false" (nzOnOk)="modSearchCustOrPolicy=false"
          nzOkText="Add"
          nzWidth="75%"
>
  <div *ngIf="modSearchCustOrPolicy">
    <div class="search-by-cust-or-policy">

      <!-- Search by ? -->
      <h3>Search by</h3>
      <nz-radio-group [(ngModel)]="searchCustOrPolicy" (ngModelChange)="searchCustOrPolicyChanged()" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="customer">
          <i nz-icon nzType="user" nzTheme="outline"></i> Customer
        </label>
        <label nz-radio-button nzValue="policy">
          <i nz-icon nzType="file-protect" nzTheme="outline"></i> Policy
        </label>
      </nz-radio-group>

      <div class="search-fields m-t-20">
        <!-- Customer Search -->
        <div *ngIf="searchCustOrPolicy=='customer'">
          <div class="tab-grid">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">First Name</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value=""/>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value="Hemsworth"/>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Gender</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'0'" style="width: 100%">
                  <nz-option [nzLabel]="'Male'" [nzValue]="'0'"></nz-option>
                  <nz-option [nzLabel]="'Female'" [nzValue]="'1'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <!-- Policy Search -->
        <div *ngIf="searchCustOrPolicy=='policy'">
          <div class="tab-grid">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Policy Number</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value="P9200199/JMSP" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Customer Name</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value="Hemsworth" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Product</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'0'" style="width: 100%">
                  <nz-option [nzLabel]="'StandardLife'" [nzValue]="'0'"></nz-option>
                  <nz-option [nzLabel]="'EndureLife'" [nzValue]="'1'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Member ID (For Group Policy)</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value="" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="multisearch-grid">
          <div>
            <button nz-button nzType="primary" (click)="searchCustOrPolicyChanged()">
              Search for {{searchCustOrPolicy | titlecase}}
            </button>
          </div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div class="search-results m-t-20">
        <!-- Show Result Tables -->
        <nz-skeleton [nzAvatar]="false"
                     [nzActive]="true" [nzTitle]="true" [nzLoading]="searchCustOrPolicyLoading">
          <!-- Customer Search Results -->
          <div *ngIf="searchCustOrPolicy=='customer'">
            <nz-table [nzData]="dataSet" [nzShowPagination]="true">
              <thead>
              <tr>
                <th>Customer No</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>C000593</td>
                <td>Chris</td>
                <td>Hemsworth</td>
                <td>17 Nov 1958</td>
                <td>M</td>
                <td><a (click)="viewAddCustomersPolicies('Chris Hemsworth (C000593)')">View & Add Policies</a></td>
              </tr>
              <tr>
                <td>C0010982</td>
                <td>Liam</td>
                <td>Hemsworth</td>
                <td>28 April 1978</td>
                <td>M</td>
                <td><a (click)="viewAddCustomersPolicies('Liam Hemsworth (C0010982)')">View & Add Policies</a></td>
              </tr>
              </tbody>
            </nz-table>

            <!-- Policies for selected customer -->
            <div *ngIf="showCustomerPolicies">
              <div class="heading-tab">
                <h3 class="heading">
                  <i nz-icon nzType="file-text"></i> Polices for {{showCustomerPoliciesName}}
                </h3>
              </div>
              <nz-table [nzData]="dataSet" [nzShowPagination]="true">
              <thead>
              <tr>
                <th></th>
                <th>Policy No</th>
                <th>Product</th>
                <th>Customer Name</th>
                <th>Customer Phone</th>
                <th>Role</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
                <td>P9200199/JMSP</td>
                <td>StandardLife</td>
                <td>Chris Hemsworth</td>
                <td>9008902991</td>
                <td>Owner</td>
                <td>Issued</td>
              </tr>
              <tr>
                <td><label nz-checkbox nzValue="B" [ngModel]="true"></label></td>
                <td>P9200199/JMSP/ADDON</td>
                <td>StandardLife</td>
                <td>Chris Hemsworth</td>
                <td>9008902991</td>
                <td>Insured</td>
                <td>Issued</td>
              </tr>
              </tbody>
            </nz-table>
            </div>

          </div>

          <!-- Policy Search Results -->
          <div *ngIf="searchCustOrPolicy=='policy'">
            <nz-table [nzData]="dataSet" [nzShowPagination]="true">
              <thead>
              <tr>
                <th></th>
                <th>Policy No</th>
                <th>Product</th>
                <th>Customer Name</th>
                <th>Customer Phone</th>
                <th>Role</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
                <td><a (click)="policyPanel(1)">P9200199/JMSP</a></td>
                <td>StandardLife</td>
                <td>Chris Hemsworth</td>
                <td>9008902991</td>
                <td>Insured</td>
                <td>Issued</td>
              </tr>
              <tr>
                <td><label nz-checkbox nzValue="B" [ngModel]="false"></label></td>
                <td><a (click)="policyPanel(1)">P92899/PROLIF/JAN18</a> <nz-tag [nzColor]="'#555'" class="point-e-0 d-i-b m-l-5">Linked</nz-tag></td>
                <td>StandardLife</td>
                <td>Chris Hemsworth</td>
                <td>9008902991</td>
                <td>Owner</td>
                <td>Issued</td>
              </tr>
              <tr>
                <td><label nz-checkbox nzValue="B" [ngModel]="true"></label></td>
                <td><a (click)="policyPanel(1)">P92UI8990/JUL18</a> <nz-tag [nzColor]="'#555'" class="point-e-0 d-i-b m-l-5">Linked</nz-tag></td>
                <td>StandardLife</td>
                <td>Chris Hemsworth</td>
                <td>9008902991</td>
                <td>Owner</td>
                <td>Issued</td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </nz-skeleton>

      </div>

    </div>
  </div>

</nz-modal>

<!-- Search CUSTOMER -->
<nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchCustomer"
          nzTitle="Search / Add Customer"
          (nzOnCancel)="modSearchCustomer=false" (nzOnOk)="modSearchCustomer=false"
          nzOkText="Select"
          nzWidth="75%"
>
<div *ngIf="modSearchCustomer">

  <nz-radio-group [(ngModel)]="searchAddCustomer" (ngModelChange)="searchCustOrPolicyChanged()" [nzButtonStyle]="'solid'" [nzSize]="'default'">
    <label nz-radio-button nzValue="search-customer">
      <i nz-icon nzType="user" nzTheme="outline"></i> Search Customer
    </label>
    <label nz-radio-button nzValue="add-customer">
      <i nz-icon nzType="user-add" nzTheme="outline"></i> Add New Customer
    </label>
  </nz-radio-group>

  <div class="search-by-cust-or-policy">
    <!-- Search -->
    <div *ngIf="searchAddCustomer=='search-customer'">
      <div class="search-fields m-t-20">
        <!-- Customer Search -->
        <div>
          <div class="tab-grid">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">First Name</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value=""/>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input value="Hemsworth"/>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Gender</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'0'" style="width: 100%">
                  <nz-option [nzLabel]="'Male'" [nzValue]="'0'"></nz-option>
                  <nz-option [nzLabel]="'Female'" [nzValue]="'1'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="multisearch-grid">
          <div>
            <button nz-button nzType="primary">
              Search Customers
            </button>
          </div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="search-results m-t-20">
        <!-- Customer Search Results -->
        <div>
          <nz-table [nzData]="dataSet" [nzShowPagination]="true">
            <thead>
            <tr>
              <th></th>
              <th>Customer No</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>DOB</th>
              <th>Gender</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <label nz-checkbox nzValue="A" [ngModel]="false"></label>
              </td>
              <td>C000593</td>
              <td>Chris</td>
              <td>Hemsworth</td>
              <td>17 Nov 1958</td>
              <td>M</td>
            </tr>
            <tr>
              <td>
                <label nz-checkbox nzValue="A" [ngModel]="true"></label>
              </td>
              <td>C0010982</td>
              <td>Liam</td>
              <td>Hemsworth</td>
              <td>28 April 1978</td>
              <td>M</td>
            </tr>
            </tbody>
          </nz-table>

        </div>
      </div>
    </div>

    <!-- Add new Customer -->
    <div *ngIf="searchAddCustomer=='add-customer'">

      <!-- ADD CUSTOMER COMPONENT -->
      <div class="add-customer">

        <div class="tab-grid m-t-20">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Title</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 100%" [ngModel]="'Mr'">
                <nz-option [nzLabel]="'Mr'" [nzValue]="'Mr'"></nz-option>
                <nz-option [nzLabel]="'Dr'" [nzValue]="'Dr'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">First Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input type="text" nz-input [ngModel]="'Chris'" style="width:100%;" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Middle Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input type="text" nz-input [ngModel]="'J'" style="width:100%;" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input type="text" nz-input [ngModel]="'Hemsworth'" style="width:100%;" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Gender</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 100%" [ngModel]="'Male'">
                <nz-option [nzLabel]="'Male'" [nzValue]="'Male'"></nz-option>
                <nz-option [nzLabel]="'Female'" [nzValue]="'Female'"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Date of birth</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

        </div>

        <!-- For HEALTH Forms -->
        <div *ngIf="productType=='underwriting-health'">
          <div class="heading-tab">
            <h3 class="heading"><i nz-icon nzType="medicine-box"></i> Details</h3>
          </div>
          <div class="tab-grid m-t-20">

            <nz-form-item>
              <nz-form-label [nzSpan]="24">Height</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group nzAddOnAfter="cms">
                  <input type="text" nz-input />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label [nzSpan]="24">Weight</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group nzAddOnAfter="kgs">
                  <input type="text" nz-input />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>

          </div>
        </div>
        <!-- /HEALTH FORMS -->

        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="form"></i> Contact Details</h3>
        </div>

        <div class="flexie-auto-grid">

          <!-- Email -->
          <div class="flex-self-vert-start">
            <h4><i nz-icon nzType="mail" nzTheme="outline"></i> Email</h4>
            <app-ui-multirow-basic type="email"></app-ui-multirow-basic>
          </div>

          <!-- Mobile -->
          <div class="flex-self-vert-start">
            <h4><i nz-icon nzType="mobile" nzTheme="outline"></i> Mobile</h4>
            <app-ui-multirow-basic type="mobile"></app-ui-multirow-basic>
          </div>

        </div>

        <app-ui-address-ind></app-ui-address-ind>

        <div *ngIf="modSearchCustomerIDVerif">
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="id-card"></i> ID Proofs</h3>
        </div>
        <!-- Upload -->
        <div class="d-b" style="min-height: 120px">

          <div>
            <h4>Type</h4>
            <nz-select nzShowSearch  [ngModel]="'0'">
              <nz-option [nzLabel]="'PAN Card'" [nzValue]="'0'"></nz-option>
              <nz-option [nzLabel]="'Aadhaar'" [nzValue]="'1'"></nz-option>
            </nz-select>
          </div>

          <div class="m-t-20">
          <nz-upload
                  nzAction="https://jsonplaceholder.typicode.com/posts/"
                  nzListType="picture-card"
                  [(nzFileList)]="fileListIDProof"
                  [nzShowButton]="fileListIDProof.length < 2"
                  [nzShowUploadList]="showUploadList"
                  [nzPreview]="handlePreview"
          >
            <i nz-icon nzType="plus"  nzTheme="outline"></i>
            <div class="ant-upload-text">Upload</div>
          </nz-upload>
          <nz-modal nzMaskClosable="false"
                  [nzVisible]="previewVisible"
                  [nzContent]="modalContent"
                  [nzFooter]="null"
                  (nzOnCancel)="previewVisible = false"
          >
            <ng-template #modalContent>
              <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
            </ng-template>
          </nz-modal>
          </div>
        </div>
        <!-- Verification Result -->
        <div class="m-t-10">
          <h3 class="col-green d-b f-s-1-3r">
            <i nz-icon nzType="check" nzTheme="outline"></i> Verified
          </h3>
          <p>
            Account Number <b>40078977300</b> matches with OCR data in cheque image
          </p>
        </div>
        </div>

      </div> <!-- /add-customer-->

    </div>
  </div>
</div>

</nz-modal>


<!-- Rejection Modal -->
<nz-modal nzMaskClosable="false" [(nzVisible)]="modRejectIntimation"
          [nzTitle]="'Reject '+stateName"
          (nzOnCancel)="modRejectIntimation=false" (nzOnOk)="modRejectIntimation=false"
          [nzOkText]="'Reject '+stateName"
          nzWidth="620px"
>
  <div *ngIf="modRejectIntimation">

    <h4>Reason for Rejection</h4>
    <input type="text" nz-input placeholder="Reason" class="d-b w-100-pc"/>

    <div class="flex flex-horiz-space-bw p-t-20">
      <h4>Remarks</h4>
      <nz-dropdown-menu>
        <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
        <ul nz-menu>
          <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
          <nz-divider class="dd-extra-hr"></nz-divider>
          <li nz-menu-item (click)="cannedModal=true">Manage Canned Replies</li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <textarea rows="2" nz-input [(ngModel)]="note"></textarea>


  </div>

</nz-modal>




<!-- modHospitalizationDetails NEW -->
<!-- Doctor Details : Add -->
<nz-modal nzMaskClosable="false" [(nzVisible)]="modHospitalizationDetails"
          nzTitle="Add Hospitalization Details"
          (nzOnCancel)="modHospitalizationDetails=false" (nzOnOk)="modHospitalizationDetails=false"
          nzOkText="Add"
          nzWidth="75%"
>
  <!-- Search and add Hospitalization -->
  <div>
    <div class="heading-tab">
      <h3 class="heading"><i nz-icon nzType="medicine-box" nzTheme="outline"></i> Hospitalization</h3>
      <button nz-button nzType="primary" (click)="modSearchAddHosp=true;">
        Search / Add Hospital
      </button>
    </div>

    <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x: '1200'}">
      <thead>
      <tr>
        <th>Name of Hospital</th>
        <th>Location</th>
        <th>Address</th>
        <th>Admission Date</th>
        <th>Discharge Date</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Fort Speciality</td>
        <td>MUMBAI</td>
        <td>Grand Trunk Road, Marine Drive, KD 2910</td>
        <td><nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></td>
        <td><nz-date-picker style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></td>
        <td>
          <a class="mutates-data does-edit" (click)="modSearchAddHosp=true">Edit</a> |
          <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
        </td>
      </tr>
      </tbody>
    </nz-table>

    <div class="heading-tab">
      <h3 class="heading"><i nz-icon nzType="reconciliation" nzTheme="outline"></i> Treating Doctor Details</h3>
      <button nz-button nzType="primary" (click)="modSearchAddDoctor=true">Search / Add Doctor</button>
    </div>

    <nz-table [nzData]="dataSet" [nzShowPagination]="false">
      <thead>
      <tr>
        <th>Doctor Name</th>
        <th>Speciality</th>
        <th>Regn. Details</th>
        <th>Treated For</th>
        <th>Remarks</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr class="v-a-top">
        <td>Dr. John Dorian</td>
        <td>Heart Surgeon</td>
        <td>RGNF09993883</td>
        <td><input type="text" nz-input ngModel="Angioplasty"></td>
        <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Critical Illness Benefit"></textarea></td>
        <td>
          <a class="mutates-data does-edit" (click)="modSearchAddDoctor=true">Edit</a> |
          <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
        </td>
      </tr>
      <tr class="v-a-top">
        <td>Dr. Rakesh Gupta</td>
        <td>General Practitioner</td>
        <td>RGNF09993883</td>
        <td><input type="text" nz-input ngModel="Sudden chest pain"></td>
        <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Critical Illness Benefit">No complications</textarea></td>
        <td>
          <a class="mutates-data does-edit" (click)="modSearchAddDoctor=true">Edit</a> |
          <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove" nzCancelText="Cancel">Remove</a>
        </td>
      </tr>
      </tbody>
    </nz-table>

  </div>
  <!-- MODAL Search and add Doctor -->
  <nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchAddDoctor"
            nzTitle="Doctor Details"
            (nzOnCancel)="modSearchAddDoctor=false" (nzOnOk)="modSearchAddDoctor=false"
            nzOkText="Add"
            nzWidth="75%"
  >
    <div *ngIf="modSearchAddDoctor">

      <nz-radio-group [(ngModel)]="tabDoc" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="search-doc">
          <i nz-icon nzType="user" nzTheme="outline"></i> Search Doctor
        </label>
        <label nz-radio-button nzValue="add-doc">
          <i nz-icon nzType="user-add" nzTheme="outline"></i> Add New Doctor
        </label>
      </nz-radio-group>

      <!-- SEARCH DOC -->
      <div *ngIf="tabDoc=='search-doc'">
        <div class="tab-grid m-t-20 p-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Doctor Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Registration No.</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Location</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="" ngModel="Mumbai"/>
            </nz-form-control>
          </nz-form-item>
          <div>
            <button nz-button nzType="primary">Search</button>
          </div>
        </div>
        <nz-table [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
          <tr>
            <th></th>
            <th>Doctor Name</th>
            <th>Speciality</th>
            <th>Regn. Details</th>
            <th>Location</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr class="v-a-top">
            <td><label nz-checkbox nzValue="true"></label></td>
            <td>Dr. John Dorian</td>
            <td>Heart Surgeon</td>
            <td>RGNF09993883</td>
            <td>Mumbai</td>
            <td>
              <a class="mutates-data does-edit" (click)="modDocDetails=true">Edit</a>
            </td>
          </tr>
          <tr class="v-a-top">
            <td><label nz-checkbox nzValue="true"></label></td>
            <td>Dr. Rakesh Gupta</td>
            <td>General Practitioner</td>
            <td>RGNF09993883</td>
            <td>Mumbai</td>
            <td>
              <a class="mutates-data does-edit" (click)="modDocDetails=true">Edit</a>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>

      <!-- ADD DOC -->
      <div *ngIf="tabDoc=='add-doc'">

        <div class="tab-grid m-t-20 p-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Doctor Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Registration No.</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Location</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="" ngModel="Mumbai"/>
            </nz-form-control>
          </nz-form-item>
        </div>

      </div>

    </div>
  </nz-modal>

  <!-- MODAL Search and add Hospital -->
  <nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchAddHosp"
            nzTitle="Hospital Details"
            (nzOnCancel)="modSearchAddHosp=false" (nzOnOk)="modSearchAddHosp=false"
            nzOkText="Add"
            nzWidth="75%"
  >
    <div *ngIf="modSearchAddHosp">

      <nz-radio-group [(ngModel)]="tabHosp" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="search-hosp">
          Search Hospital
        </label>
        <label nz-radio-button nzValue="add-hosp">
          Add New Hospital
        </label>
      </nz-radio-group>

      <!-- SEARCH HOSPITAL -->
      <div *ngIf="tabHosp=='search-hosp'">
        <div class="tab-grid m-t-20 p-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Hospital Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Location</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="" ngModel="Mumbai"/>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <button nz-button nzType="primary">Search</button>
        </div>
        <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x: '1200'}">
          <thead>
          <tr>
            <th></th>
            <th>Name of Hospital</th>
            <th>Location</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <nz-radio-group [(ngModel)]="selectedHosp">
                <label nz-radio nzValue="A"></label>
              </nz-radio-group>
            </td>
            <td>Fort Speciality</td>
            <td>MUMBAI</td>
            <td>Grand Trunk Road, Marine Drive, KD 2910</td>
            <td>
              <a class="mutates-data does-edit" (click)="modHospDetails=true">Edit</a>
            </td>
          </tr>
          <tr>
            <td>
              <nz-radio-group [(ngModel)]="selectedHosp">
                <label nz-radio nzValue="B"></label>
              </nz-radio-group>
            </td>
            <td>PV Hospital</td>
            <td>MUMBAI</td>
            <td>Vista 494, South KR, Fort</td>
            <td>
              <a class="mutates-data does-edit" (click)="modHospDetails=true">Edit</a>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>

      <!-- ADD HOSPITAL -->
      <div *ngIf="tabHosp=='add-hosp'">
        <div class="tab-grid m-t-20 p-b-10">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Hospital Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Location</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="" ngModel="Mumbai"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Address</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <textarea nz-input nzAutosize placeholder="Address"></textarea>
            </nz-form-control>
          </nz-form-item>

        </div>

      </div>

    </div>
  </nz-modal>
  <!-- / Search and add Hospitalication -->
</nz-modal>


<!-- Hidden Content -- DRAWERS -->

<!-- NOTES -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="notesPanelOpen" [nzPlacement]="'right'"
           nzTitle="Notes"
           (nzOnClose)="notesPanel(0)">
  <div>

    <div class="flex flex-horiz-space-bw">
      <h4>Enter your Notes</h4>
      <nz-dropdown-menu>
        <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
        <ul nz-menu>
          <li nz-menu-item (click)="noteCannedReply(0)">Please have a look at the ...</li>
          <li nz-menu-item (click)="noteCannedReply(1)">Requesting additional investigation ...</li>
          <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
          <nz-divider class="dd-extra-hr"></nz-divider>
          <li nz-menu-item (click)="cannedModal=true">Manage Canned Replies</li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <textarea rows="2" nz-input [(ngModel)]="note"></textarea>

    <h4 class="d-b m-t-10">Attach Files</h4>
    <!--<input type="file" name="fileClaimNoteAdd" id="fileClaimNoteAdd">-->
    <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/">
      <button nz-button><i nz-icon class="anticon anticon-upload"></i><span>Click to Upload</span></button>
    </nz-upload>

    <h4 class="d-b m-t-10">Visibility</h4>
    <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select post visibility">
      <nz-option nzLabel="Private (only me)" nzValue="0"></nz-option>
      <nz-option nzLabel="Public (everyone)" nzValue="1"></nz-option>
    </nz-select>

    <div class="m-t-20">
      <h4 class="d-i-b m-r-10">Posting as</h4>
      <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
      John Doe
    </div>

    <button nz-button nzType="primary" class="m-t-20">Add Note</button>

    <nz-divider nzText="Notes" class="m-t-20"></nz-divider>


    <div>
      <div class="list-note">
        <!--<div class="list-note-avatar">
          <nz-avatar nzIcon="anticon anticon-user"></nz-avatar>
        </div>-->
        <div class="list-note-content">
          <h4 class="list-note-title"><i class="anticon anticon-message"></i> Ryan Reynolds</h4>
          <div class="list-note-description">
              Please verify document proofs submitted. Especially the bills from Sacred Hearts Hospital.
            <br>
            Visibility: Private
            <br>
            Stage: Claim Investigation
          </div>
        </div>
        <div class="list-note-content">
          <h4 class="list-note-title"><i class="anticon anticon-message"></i> Jack Nick</h4>
          <div class="list-note-description">
            All documents seems to be in place
            <br>
            Attachment: <a>CLM0000107_VERIFICAITION.jpg</a>
            <br>
            Visibility: Private
            <br>
            Stage: Claim Registration
          </div>
        </div>
        <div class="list-note-content">
          <span class="flex flex-horiz-space-bw">
            <h4 class="list-note-title"><i class="anticon anticon-message"></i> John Doe</h4>
            <i class="anticon anticon-delete col-red clickable" nz-popconfirm nzPopconfirmTitle="Delete note?" nzOkText="Delete" nzCancelText="Cancel" ></i>
          </span>
          <div class="list-note-description">
            Note to registration stage: Please verify Bank documents
            <br>
            Visibility: Public <i nz-icon nzType="global" nzTheme="outline"></i>
            <br>
            Stage: Claim Intimation
          </div>
        </div>
      </div>
    </div>
  </div>
</nz-drawer>

<!-- POLICY DETAILS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="policyPanelOpen" [nzPlacement]="'right'"
           nzTitle="#PLF-00001-0001 Details"
           [nzOffsetX]="profilePanelOpen ? 80 : 0"
           (nzOnClose)="policyPanel(0)">

  <!-- Dropdown to select policy -->
  <div class="p-b-20">
    <nz-select nzShowSearch  ngModel="P0030547" class="d-b w-100-pc">
      <nz-option [nzLabel]="'P0030547'" [nzValue]="'P0030547'"></nz-option>
      <nz-option [nzLabel]="'P0067008'" [nzValue]="'P0067008'"></nz-option>
    </nz-select>
  </div>

  <!-- All data below changes on above dropdown change -->
  <!-- Title -->
  <div class="title-emphasis">
    <i class="title-ico anticon anticon-file-protect"></i>
    <div>
      <h4 class="p-0 m-0">StandardLife</h4>
      <span class="col-grey-dark">PLF-00001-0001</span>
    </div>
  </div>

  <!-- Summary -->
  <h3 class="p-b-20 f-w-600 f-s-1r">Details</h3>
  <div class="summary-container">
    <div>
      <span class="s-c-head">Policy No</span> PLF-00001-0001
    </div>
    <div>
      <span class="s-c-head">Policy Owner</span>
      <a (click)="profilePanel(1)">Chris Hemsworth</a>
    </div>
    <div>
      <span class="s-c-head">Product</span> StandardLife
    </div>
    <div>
      <span class="s-c-head">Plan</span> Individual
    </div>
    <div>
      <span class="s-c-head">Package</span> SILVER
    </div>
    <div>
      <span class="s-c-head">Premium Status</span>
      <nz-tag [nzColor]="'#87d068'">PAID</nz-tag>
    </div>
    <div>
      <span class="s-c-head">Commencement Date</span>
      13-11-2018 <small class="d-b">(~5 months ago w.r.t Event Date)</small>
    </div>
    <div>
      <span class="s-c-head">Policy Expiry Date</span>
      <nz-badge nzStatus="success">12-11-2019 </nz-badge>
      <small class="d-b">(in 6 months w.r.t Event Date)</small>
    </div>
    <div>
      <span class="s-c-head">Total Sum Insured</span> Rs 1 Cr.
    </div>
    <div>
      <span class="s-c-head">Premium</span> Rs 5400
    </div>

  </div>

  <!-- Coverages -->
  <div class="p-t-20">
    <!--<h3 class="p-t-b-20 f-w-600 f-s-1r">Coverages</h3>-->
    <nz-table #smallTableofCoverages nzSize="small" [nzData]="dataSet" [nzShowPagination]="false">
      <thead>
      <tr>
        <th>Coverage</th>
        <th>Sum Insured</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Health Checkup</td>
        <td>Rs. 90,000</td>
      </tr>
      <tr>
        <td>Restore Benefits</td>
        <td>Rs. 1,00,000</td>
      </tr>
      <tr>
        <td>Ambulance Cost</td>
        <td>Rs. 50,000</td>
      </tr>
      </tbody>
    </nz-table>
  </div>

</nz-drawer>

<!-- CLAIMS Worksheet -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="worksheetPanelOpen" [nzPlacement]="'right'"
           nzTitle="Worksheet"
           (nzOnClose)="worksheetPanel(0)">

  <!-- Title -->
  <div class="title-emphasis">
    <i class="title-ico anticon anticon-file-protect"></i>
    <div>
      <h4 class="p-0 m-0"><span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</h4>
      <span class="col-grey-dark">#CLM0000107</span>
    </div>
  </div>

  <!-- Summary -->
  <div class="summary-container">
    <div>
      <span class="s-c-head">Policy No</span> PLF-00001-0001
    </div>
    <div>
      <span class="s-c-head">Policy Owner</span>
      <a (click)="profilePanel(1)">Chris Hemsworth</a>
    </div>
    <div>
      <span class="s-c-head">Product</span> StandardLife
    </div>
    <div>
      <span class="s-c-head">Plan</span> Individual
    </div>
    <div>
      <span class="s-c-head">Package</span> SILVER
    </div>
    <div>
      <span class="s-c-head">Premium Status</span>
      <nz-tag [nzColor]="'#87d068'">PAID</nz-tag>
    </div>
    <div>
      <span class="s-c-head">Commencement Date</span>
      13-11-2018 <small class="d-b">(~5 months ago)</small>
    </div>
    <div>
      <span class="s-c-head">Policy Expiry Date</span>
      <nz-badge nzStatus="success">12-11-2019 </nz-badge>
      <small class="d-b">(in 6 months)</small>
    </div>
    <div>
      <span class="s-c-head">Total Sum Insured</span> Rs 1 Cr.
    </div>
    <div>
      <span class="s-c-head">Premium</span> Rs 5400
    </div>
  </div>

  <!-- TimeLines -->
  <h4 class="p-t-b-20 d-b">Activity Timeline</h4>
  <nz-timeline>
    <nz-timeline-item nzColor="orange">
      <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
      <p>
        Investigator: G. Fadango <br>
        Status: Being Investigated
      </p>
    </nz-timeline-item>
    <nz-timeline-item nzColor="orange">
      <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
      <p>
        Notes: Correspondence sent to Claimant
      </p>
    </nz-timeline-item>
    <nz-timeline-item nzColor="green">
      <h4 class="f-w-600">eMail to Claimant <nz-tag [nzColor]="'green'">Sent</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
      <p>
        To: riya@gmail.com <br>
        Message: Your claim is being processed <br>
        Attachment: <a>CLM0000107.EML</a>
      </p>
    </nz-timeline-item>

  </nz-timeline>


</nz-drawer>

<!-- CUSTOMER PROFILE DETAILS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
           nzTitle="Customer Profile"
           (nzOnClose)="profilePanel(0)">

  <!-- Title -->
  <div class="title-emphasis">
    <i class="title-ico anticon anticon-contacts"></i>
    <div>
      <h4 class="p-0 m-0">Chris Hemsworth</h4>
      <span class="col-grey-dark">19 Dec 1990 (29 years)</span>
    </div>
  </div>

  <!-- Summary -->
  <div class="summary-container">
    <div>
      <span class="s-c-head">Insured Name</span> Chris Hemsworth
    </div>
    <div>
      <span class="s-c-head">Gender</span> Male
    </div>
    <div>
      <span class="s-c-head">Product</span> StandardLife
    </div>
    <div>
      <span class="s-c-head">Date of Birth</span> 19-12-1990
    </div>
    <div>
      <span class="s-c-head"> Country Of Birth</span> India
    </div>
    <div>
      <span class="s-c-head">Citizenship</span> Indian
    </div>
  </div>

  <h3 class="heading heading-summary">Identity</h3>

  <div class="summary-container">
    <div>
      <span class="s-c-head">KTP</span> K-0123
    </div>
    <div>
      <span class="s-c-head">PAN</span> AUORT7827R
    </div>
  </div>

  <h3 class="heading heading-summary">Contact</h3>
  <div>
    <nz-table nzSize="small" [nzData]="[1]" [nzShowPagination]="false" class="p-b-20 d-b">
      <thead>
      <tr>
        <th>Email</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>hemsworth@altizone.co</td>
        <td>Business</td>
      </tr>
      <tr>
        <td>chris.thor@gmail.com</td>
        <td>Personal</td>
      </tr>
      </tbody>
    </nz-table>
    <nz-table nzSize="small" [nzData]="[1]" [nzShowPagination]="false">
      <thead>
      <tr>
        <th>Phone</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>+01-456-8973</td>
        <td>Business</td>
      </tr>
      <tr>
        <td>+91-9503144092</td>
        <td>Personal</td>
      </tr>
      </tbody>
    </nz-table>
  </div>

  <h3 class="heading heading-summary">Address</h3>

  <div class="summary-container">
    <div>
      <span class="s-c-head">Home</span> A/803, Ridge Bay, Krent Road, East State - 1009
    </div>
    <div>
      <span class="s-c-head">Business</span> Mimic Co. F43, WorkSpaze, East State - 1012
    </div>
  </div>

</nz-drawer>

<!-- CORRESPONDENCE -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Correspondence with Chris Hemsworth"
           [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
  <div>

    <div class="p-b-10 flex flex-horiz-space-bw">
      <div></div>
      <button nz-button nzType="primary" (click)="openCorrModal()">New Correspondence</button>
    </div>

    <nz-timeline>
      <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag></h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: riya@gmail.com <br>
          Message: Your claim is being processed <br>
          Attachment: <a>CLM0000107.EML</a>
        </p>
      </nz-timeline-item>
      <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag></h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your claim is being processed
        </p>
      </nz-timeline-item>
    </nz-timeline>
  </div>
</nz-drawer>

<!-- DOCUMENTS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Documents"
           [nzVisible]="docuPanelOpen" (nzOnClose)="docuPanel(0)">

  <div *ngIf="docuPanelOpen">

    <nz-collapse [nzBordered]="true">
      <nz-collapse-panel
              *ngFor="let panel of uploadArray; let i = index;"
              [nzHeader]="panel.name">
        <div>
          <!-- Selection of Type -->
          <div class="flex flex-horiz-space-bw p-b-10">
            <div>
              <nz-select nzShowSearch  [ngModel]="panel.id">
                <nz-option [nzLabel]="panel.reqName" [nzValue]="panel.id"></nz-option>
                <nz-option [nzLabel]="'Passport'" [nzValue]="101"></nz-option>
                <nz-option [nzLabel]="'PAN Card'" [nzValue]="102"></nz-option>
              </nz-select>
            </div>
            <span>
              <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this section?" nzOkText="Remove" nzCancelText="Cancel" (nzOnConfirm)="removeUploadRow()"><i class="anticon anticon-delete"></i></button>
        </span>
          </div>
          <!-- Upload -->
          <nz-upload
                  class="upload-list-inline"
                  nzAction="https://jsonplaceholder.typicode.com/posts/"
                  nzListType="picture"
                  [(nzFileList)]="defaultUploadsList"
          >
            <button nz-button>
              <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
            </button>
          </nz-upload>

          <h4 class="d-b m-t-10">Requested Date</h4>
          <nz-date-picker nzShowTime style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

          <h4 class="d-b m-t-10">Received Date</h4>
          <nz-date-picker nzShowTime style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

          <div class="flexie-auto-grid">
            <div>
              <h4 class="d-b m-t-10">Visibility</h4>
              <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select post visibility">
                <nz-option nzLabel="Private (only me)" nzValue="0"></nz-option>
                <nz-option nzLabel="Public (everyone)" nzValue="1"></nz-option>
              </nz-select>
            </div>
            <div>
              <h4 class="d-b m-t-10">Status</h4>
              <nz-select nzShowSearch  class="w-100-pc" [ngModel]="'0'">
                <nz-option [nzLabel]="'Identified'" [nzValue]="'1'"></nz-option>
                <nz-option [nzLabel]="'Waived'" [nzValue]="'0'"></nz-option>
                <nz-option [nzLabel]="'Received'" [nzValue]="'2'"></nz-option>
                <nz-option [nzLabel]="'Fullfilled'" [nzValue]="'3'"></nz-option>
              </nz-select>
            </div>
          </div>

          <h4 class="d-b m-t-10">Comments</h4>
          <textarea class="w-100-pc" rows="2" nz-input placeholder="Comments"></textarea>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <button nz-button (click)="addUploadRow()" class="d-b m-t-20">Add More</button>

  </div>

</nz-drawer>


<!-- Error Panel -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Exceptions"
           [nzVisible]="errPanelOpen" (nzOnClose)="errDetailsPanel(0)">
  <div *ngIf="errPanelOpen">

    <!-- Errors List -->
    <div>
      <strong class="col-grey-dark">Basic Details</strong>
      <ul class="error-list">
        <li>
          <span>`Event Date` is required</span> &bull; <a (click)="errJumpTo(0,'eventDate')">View</a>
        </li>
        <li>
          <span>`Event Time` is required</span> &bull; <a (click)="errJumpTo(0,'eventDate')">View</a>
        </li>
      </ul>

      <strong class="col-grey-dark">Bank Details</strong>
      <ul class="error-list">
        <li>
          <span class="">`IFSC Code` is invalid</span> &bull; <a (click)="errJumpTo(4,'ifscCode')">View</a>
          <br><label nz-checkbox nzValue="true" ngModel="true">Override</label> (Manager+)
        </li>
      </ul>
    </div>


  </div>
</nz-drawer>


<!-- PENDING TASKS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Pending Tasks"
           [nzVisible]="pendingPanelOpen" (nzOnClose)="pendingPanel(0)">

  <div *ngIf="pendingPanelOpen">

    <nz-timeline>
      <nz-timeline-item nzColor="orange">
        <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          Investigator: G. Fadango <br>
          Status: Being Investigated
        </p>
      </nz-timeline-item>
      <nz-timeline-item nzColor="orange">
        <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          Notes: Correspondence sent to Claimant
        </p>
      </nz-timeline-item>
    </nz-timeline>

  </div>


</nz-drawer>

<!-- Workflow -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Activity / Workflow"
           [nzVisible]="workflowPanelOpen" (nzOnClose)="workflowPanel(0,0)">
  <div>

    <div class="flex p-b-40" *ngIf="showDropdown">
      <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select view">
        <nz-option nzLabel="Everything" nzValue="0"></nz-option>
        <nz-option nzLabel="Workflow Audit" nzValue="1"></nz-option>
        <nz-option nzLabel="Customer Correspondence" nzValue="2"></nz-option>
      </nz-select>
    </div>

  <nz-timeline>
    <nz-timeline-item nzColor="orange">
      <h4 class="f-w-600">Claim Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i> 5 Apr 2019 11:11 AM (5 days ago)</p>
      <p>
        Work queue: Investigation Level 1 <br>
        Assignee: aditya@metamorphtech.com
      </p>
    </nz-timeline-item>
    <nz-timeline-item nzColor="orange">
      <h4 class="f-w-600">Claim Adjudication <nz-tag [nzColor]="'orange'">Pending</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i> 5 Apr 2019 11:11 AM (5 days ago)</p>
      <p>
        Work queue: Adjudication Level 1 <br>
        Assignee: kewal@metamorphtech.com
      </p>
    </nz-timeline-item>
    <nz-timeline-item nzColor="green">
      <h4 class="f-w-600">Claim Registration <nz-tag [nzColor]="'green'">Completed</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i> 4 Apr 2019 11:10 AM (6 days ago)</p>
      <p>
        Work queue: Registration {{productTypeConfig?.prodSubType}} <br>
        Assignee: ganesh@metamorphtech.com <br>
        Priority: High <br>
        Completed in: 1 hour
      </p>
    </nz-timeline-item>
    <nz-timeline-item nzColor="green">
      <h4 class="f-w-600">Claim Intimation <nz-tag [nzColor]="'green'">Completed</nz-tag></h4>
      <p><i class="anticon anticon-calendar"></i> 5 Apr 2019 10:12 AM (5 days ago)</p>
      <p>
        Work queue: {{productTypeConfig?.prodSubType}} <br>
        Assignee: kewal@metamorphtech.com <br>
        Priority: High <br>
        Completed in: 2 hours
      </p>
    </nz-timeline-item>
  </nz-timeline>
  </div>

</nz-drawer>


<!-- Analytics -->

<nz-modal [(nzVisible)]="analyticsModal" nzTitle="Analytics" (nzOnCancel)="analyticsModal=false" (nzOnOk)="analyticsModal=false" nzOkText="Ok" nzWidth="800px" nzZIndex="100">
  <div *ngIf="analyticsModal">
    <!-- <app-ui-analytics-tab mode="tab"></app-ui-analytics-tab> -->
  </div>
</nz-modal>


<nz-modal [(nzVisible)]="cannedModal" nzTitle="Manage Canned Replies" (nzOnCancel)="cannedModal=false" (nzOnOk)="cannedModal=false" nzOkText="Save" nzWidth="600px" nzZIndex="4">
  <div *ngIf="cannedModal">
    <app-ui-canned-replies></app-ui-canned-replies>
  </div>
</nz-modal>





<!-- END Hidden Content -->

